var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRoundedNew = function SvgArrowRoundedNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3902 7.33398H1.99967C1.63148 7.33398 1.33301 7.63246 1.33301 8.00065C1.33301 8.36884 1.63148 8.66732 1.99967 8.66732H12.3902L10.8616 10.1959C10.6013 10.4563 10.6013 10.8784 10.8616 11.1387C11.122 11.3991 11.5441 11.3991 11.8044 11.1387L14.4711 8.47206C14.7314 8.21171 14.7314 7.7896 14.4711 7.52925L11.8044 4.86258C11.5441 4.60223 11.122 4.60223 10.8616 4.86258C10.6013 5.12293 10.6013 5.54504 10.8616 5.80539L12.3902 7.33398Z"
  })));
};
export default SvgArrowRoundedNew;